var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3134_19577",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3134_19577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0533 12.0005L15.1264 7.92737C15.2649 7.78892 15.3357 7.61489 15.3389 7.40527C15.3421 7.19568 15.2713 7.01844 15.1264 6.87357C14.9816 6.72869 14.8059 6.65625 14.5995 6.65625C14.3931 6.65625 14.2175 6.72869 14.0726 6.87357L9.5784 11.3678C9.4848 11.4614 9.41877 11.5601 9.38032 11.6639C9.34186 11.7678 9.32262 11.88 9.32262 12.0005C9.32262 12.121 9.34186 12.2332 9.38032 12.337C9.41877 12.4408 9.4848 12.5396 9.5784 12.6331L14.0726 17.1274C14.2111 17.2658 14.3851 17.3367 14.5947 17.3399C14.8043 17.3431 14.9816 17.2723 15.1264 17.1274C15.2713 16.9825 15.3438 16.8069 15.3438 16.6005C15.3438 16.3941 15.2713 16.2184 15.1264 16.0736L11.0533 12.0005Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.8164635f9e8c0ff269c93f65bff3f163.svg";
export { ForwardRef as ReactComponent };